import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import { motion } from "framer-motion";
import fondo from "../../Image/nuestros-servicios-hod-61.png";

export const PortadaServicio = () => {


  return (
    <Box
      sx={{
        backgroundImage: `url(${fondo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        marginTop: '70px',
        minHeight: "50vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#fff",
        '@media (max-width:600px)': {
                    marginTop: '40px'
    },
     '@media (max-width:500px)': {
                     minHeight: "70vh",
    },

      }}
    >
      <Container maxWidth='md'>
        <Grid container spacing={4} sx={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'center',
          alignItems: 'center',
           '@media (max-width:600px)': {
                    padding:'0px 40px'
                  },
                  '@media (max-width:306px)': {
                    padding:'0px 20px'
                  },
        }} >
          <Grid size={{ xs: 12, sm: 5 }}>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Typography variant="h2"
                sx={{
                  fontWeight: "400",
                  color: '#1A425B',
                  fontFamily: "Montserrat",
                  textTransform: 'uppercase',
                  margin: 0,
                  '@media (max-width:899px)': {
                    fontSize: '2rem'
                  },
                   '@media (max-width:300px)': {
                    fontSize: '1.5rem'
                  },
                  
                }}>
                Nuestros
              </Typography>
              <Typography variant="h2"
                sx={{
                  fontWeight: "700",
                  color: '#1A425B',
                  fontFamily: "Montserrat",
                  textTransform: 'uppercase',
                  margin: 0,
                  '@media (max-width:899px)': {
                    fontSize: '2rem'
                  },
                   '@media (max-width:300px)': {
                    fontSize: '1.5rem'
                  },
                }}>
                Servicios
              </Typography>
            </motion.div>
          </Grid>
          <Grid size={{ xs: 12, sm: 7 }}>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "500",
                  color: '#1A425B',
                  fontFamily: "Montserrat",
                  textAlign: 'justify',
                  marginBottom: '30px',
                  '@media (max-width:899px)': {
                    fontSize: '1rem',
                    letterSpacing: 0
                  },
                   '@media (max-width:600px)': {
                    fontSize: '0.9rem'
                  },
                   '@media (max-width:306px)': {
                    fontSize: '0.8rem'
                  },
                }}>
                En un mundo donde la automatización y la
                comodidad son clave, en HOD llevamos la
                experiencia del vending a otro nivel.
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: "500",
                  color: '#1A425B',
                  fontFamily: "Montserrat",
                  textAlign: 'justify',
                  '@media (max-width:899px)': {
                    fontSize: '1rem',
                    letterSpacing: 0
                  },
                  '@media (max-width:600px)': {
                    fontSize: '0.9rem'
                  },
                   '@media (max-width:306px)': {
                    fontSize: '0.8rem'
                  },
                }}>
                Entregando soluciones vending integrales
                y personalizadas, adaptadas a las
                necesidades de cada cliente.
              </Typography>

            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};